// extracted by mini-css-extract-plugin
export default {"container":"ImageSlider_container__kOKTR"};